import { atom, atomFamily } from 'recoil';

import { QueryStatus } from 'react-query';

import {
  DeliveryDashboardData,
  GiftDeliveryForAdmin,
  GiftDeliveryStatistics,
} from './giftDelivery.interface';

// Admin 배송 대시보드
export const deliveryDashboardStatusAtom = atom<QueryStatus>({
  key: 'deliveryDashboardStatusAtom',
  default: 'idle',
});

export const deliveryDashboardDataAtom = atom<DeliveryDashboardData | null>({
  key: 'deliveryDashboardDataAtom',
  default: null,
});

// Admin 배송 통계
export const giftDeliveryStatisticsStatusAtom = atom<QueryStatus>({
  key: 'giftDeliveryStatisticsStatusAtom',
  default: 'idle',
});

export const giftDeliveryStatisticsDataAtom = atom<GiftDeliveryStatistics | null>({
  key: 'giftDeliveryStatisticsDataAtom',
  default: null,
});

// Admin 배송 검색 결과
export const giftDeliverySearchStatusAtomFamily = atomFamily<QueryStatus, string>({
  key: 'giftDeliverySearchStatusAtomFamily',
  default: 'idle',
});

export const giftDeliverySearchDataAtomFamily = atomFamily<
  GiftDeliveryForAdmin[],
  string
>({
  key: 'giftDeliverySearchDataAtomFamily',
  default: [],
});

// BugoAgencyAdmin 배송 대시보드
export const agencyDeliveryDashboardStatusAtom = atom<QueryStatus>({
  key: 'agencyDeliveryDashboardStatusAtom',
  default: 'idle',
});

export const agencyDeliveryDashboardDataAtom = atom<DeliveryDashboardData | null>({
  key: 'agencyDeliveryDashboardDataAtom',
  default: null,
});

// BugoAgencyAdmin 배송 통계
export const agencyDeliveryStatisticsStatusAtom = atom<QueryStatus>({
  key: 'agencyDeliveryStatisticsStatusAtom',
  default: 'idle',
});

export const agencyDeliveryStatisticsDataAtom = atom<GiftDeliveryStatistics | null>({
  key: 'agencyDeliveryStatisticsDataAtom',
  default: null,
});
